// React
import PropTypes from "prop-types";
import { useContext, useEffect, useRef, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Collapse,
  Fade,
  Grid,
  Icon,
  InputLabel,
  Modal,
  Tooltip,
} from "@mui/material";

import { gql, useLazyQuery, useMutation } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import { formatMoneyPunto } from "utils/formatters";
import dayjs from "dayjs";
import { ConfirmarContext } from "context/ConfirmarContext";
import MiniStatisticsCard from "components/Cards/StatisticsCards/MiniStatisticsCard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalMotivo({ open, handleClose, idPermiso }) {
  const { handleSnackbar } = useContext(MessageManager);
  const [documento, setDocumento] = useState();
  const inputRef = useRef();
  const [file, setFile] = useState();
  const { confirmar } = useContext(ConfirmarContext);

  const [getPermiso, { data, loading }] = useLazyQuery(gql`
    query getPermiso($id: ID!) {
      permisoGob(id: $id) {
        tipo
        estado
        fechaInicio
        motivoRechazo
        fechaVencimiento
        usuario {
          nombre
          apellido
          dni
          email
        }
        medioDePago
        comprobantesPago {
          id
          nombre
          file
          estado
        }
      }
    }
  `);

  useEffect(() => {
    if (idPermiso && open) {
      getPermiso({ variables: { id: idPermiso } });
    }
  }, [idPermiso, open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Permiso rechazado</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputLabel htmlFor="fechaPermiso">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Motivo del rechazo
                    </SoftTypography>
                  </InputLabel>
                  <SoftTypography variant="h6">{data?.permisoGob?.motivoRechazo}</SoftTypography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputLabel htmlFor="fechaPermiso">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Tipo de permiso
                    </SoftTypography>
                  </InputLabel>
                  <SoftTypography variant="h6">{data?.permisoGob?.tipo}</SoftTypography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputLabel htmlFor="fechaPermiso">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Medio de pago
                    </SoftTypography>
                  </InputLabel>
                  <SoftTypography variant="h6">{data?.permisoGob?.medioDePago}</SoftTypography>
                </Grid>

                <Grid item xs={12}>
                  <SoftTypography variant="h6" fontWeight="light">
                    Si cree que esto se debe a un error, por favor cumincarse a través de correo o
                    teléfono para resolver su situación. En caso contrario deberá solicitar un
                    permiso nuevamente.
                  </SoftTypography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    window.open(`mailto:permisodepescasanluis@gmail.com`, "_blank");
                  }}
                >
                  <MiniStatisticsCard
                    title={{ text: "Email para reclamos" }}
                    count={"permisodepescasanluis@gmail.com"}
                    icon={{ color: "primary", component: "email" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    window.open(`tel:+54902664452000`, "_blank");
                  }}
                >
                  <MiniStatisticsCard
                    title={{ text: "Teléfono para reclamos" }}
                    count={"02664-452000"}
                    icon={{ color: "primary", component: "phone" }}
                  />
                </Grid>
              </Grid>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalMotivo.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  idPermiso: PropTypes.string,
};
